@use "@design/design-tokens/typography/typography" as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

.root {
  display: flex;
  flex-direction: column;
  border-left: 1px solid var(--border-soft);
}

.item {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  border: none;
  border-left: 2px solid transparent;
  background: none;
  color: var(--text-default);
  cursor: pointer;
  @include typography-v2-body-sm;

  &:hover {
    color: var(--text-primary);
  }
}

.active {
  color: var(--text-primary);
  border-left-color: var(--border-primary);
}

.downloadButton {
  align-self: flex-start;
  margin: 12px;
  @include border-radius-r2;
}
